@if (searchTerm$ | async; as searchTerm) {
<!-- search result with products -->
@if ((numberOfItems$ | async) || (filterParams$ | async)) {
<ish-search-result [searchTerm]="searchTerm" [totalItems]="numberOfItems$ | async" [deviceType]="deviceType$ | async" />
} @else { @if ((searchLoading$ | async) === false) {
<ish-search-no-result [searchTerm]="searchTerm" />
} }
<!-- empty search result -->
@if (searchLoading$ | async) {
<ish-loading />
} }
